module.exports = __webpack_public_path__ + "static/01-4882e4a38cf52263b726db5129039a64.jpg";